import React, { useState } from 'react';
import { string } from 'prop-types';
import { FormattedMessage } from '../../../util/reactIntl';
import classNames from 'classnames';

import { equipmentShop, metrics1 } from '../data';
import { NamedLink } from '../../../components';

import css from './SectionEquipmentShop.module.css';


import SectionMetrics from '../SectionMetrics/SectionMetrics';

const blockItems = equipmentShop.map((item, index) => {
  return <li key={index} className={css.itemHolder}>
    <div className={css.itemTitleHolder}>
      <h3 className={css.itemTitle}>{item.title}</h3>
      <img className={css.itemImage} src={item.img} alt={item.title} />
      <p className={css.itemDescription}>{item.description}</p>
    </div>
  </li>
})

const SectionEquipmentShop = props => {

  const { rootClassName, className } = props;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <div className={classes}>
      <div className={css.content}>
        <h3 className={css.mainTitle}>
          <FormattedMessage id="SectionEquipmentShop.title" />
        </h3>
        <h4 className={css.subTitle}>
          <FormattedMessage id="SectionEquipmentShop.subTitle" />
        </h4>

        <ul className={css.itemsList}>{blockItems}</ul>
        <SectionMetrics  data={metrics1}/>

      </div>
    </div>
  );
};

SectionEquipmentShop.defaultProps = { rootClassName: null, className: null };

SectionEquipmentShop.propTypes = {
  rootClassName: string,
  className: string,
};

export default SectionEquipmentShop;
